import { createRoutine } from "redux-saga-routines";


export const entranceTest = createRoutine("TESTS/ENTRANCE");
export const loadOne = createRoutine("TESTS/LOAD_ONE");
export const saveOne = createRoutine("TESTS/SAVE_ONE");
export const finishTest = createRoutine("TESTS/FINISH");